import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { useTranslation } from 'react-i18next'

export default function WelcomeLoader() {
  const { t } = useTranslation('chat')
  const localTips = t('welcome.tips', { returnObjects: true }) as string[]

  const [index, setIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(i => (i + 1) % localTips.length)
    }, 3500)
    return () => clearInterval(interval)
  }, [localTips.length])

  return (
    <div className="flex flex-col items-center justify-center h-full px-6">
      {/* Logo with gold glow */}
      <div className="relative">
        <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(200,149,48,0.1)_0%,transparent_60%)] scale-[3]" />
        <motion.img
          src="/tendbot.png"
          alt="TendBot"
          className="h-16 w-auto relative"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        />
      </div>

      {/* Gold divider */}
      <motion.div
        className="h-px w-24 bg-gradient-to-r from-transparent via-gold/40 to-transparent mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      />

      {/* Rotating tips */}
      <div className="mt-8 h-8 flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.p
            key={index}
            className="text-pearl/50 text-sm italic text-center"
            initial={{ opacity: 0, y: 5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            {localTips[index]}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>
  )
}
